import { MapState } from "../../types";

export const resetPlannedRoutes = (state: MapState) => {
  state.routes.planId = undefined;
  state.routes.plannedRoutes = [];
  state.routes.plannedRoutesLoadingStatus = undefined;
  state.routes.routeStations = [];
  state.routes.routeStationsLoadingStatus = undefined;
  state.routes.routePrices = [];
  state.routes.stationServicePrices = {};
  state.routes.routePricesLoadingStatus = undefined;
}
